import { render, staticRenderFns } from "./RejectSepaReturnRequestModal.vue?vue&type=template&id=5d3ed1a8"
import script from "./RejectSepaReturnRequestModal.vue?vue&type=script&lang=js"
export * from "./RejectSepaReturnRequestModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports